'use client';

import { useTranslations } from 'next-intl';
import * as React from 'react';

const SvgYoutubeFooter = () => {
  const t = useTranslations();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      fillRule="evenodd"
      clipRule="evenodd"
      imageRendering="optimizeQuality"
      shapeRendering="geometricPrecision"
      textRendering="geometricPrecision"
      viewBox="0 0 5067 5067"
      aria-label={t('aria.youtube_icon')}
    >
      <rect width="5067" height="5067" fill="#ed2524" rx="489" ry="489"></rect>
      <path
        fill="#fefefe"
        d="M3110 2497l-933 504V1989l421 229 512 279zm1116-684s-33-248-137-357c-131-144-278-145-346-153-483-36-1208-36-1208-36h-2s-725 0-1209 36c-67 8-214 9-346 153-103 109-137 357-137 357s-35 292-35 583v274c0 291 35 583 35 583s34 248 137 357c132 144 304 139 381 154 277 28 1175 36 1175 36s726-1 1209-37c68-9 215-9 346-153 104-109 137-357 137-357s35-292 35-583v-274c0-291-35-583-35-583z"
      ></path>
    </svg>
  );
};
// const SvgYoutubeFooter = (props: SVGProps<SVGSVGElement>) => (
//   <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.87 28.87">
//     <g data-name="Layer 2">
//       <g data-name="Layer 1">
//         <rect
//           width="28.87"
//           height="28.87"
//           fill="#fd3832"
//           rx="6.48"
//           ry="6.48"
//         ></rect>
//         <path
//           fill="#fff"
//           fillRule="evenodd"
//           d="M8 19.77a1.88 1.88 0 01-1.24-1.21c-.54-1.48-.7-7.66.34-8.88A2 2 0 018.46 9c2.79-.3 11.41-.26 12.4.1a1.94 1.94 0 011.22 1.17c.59 1.53.61 7.09-.08 8.56a1.89 1.89 0 01-.87.88c-1.04.52-11.75.51-13.13.06zm4.43-2.9l5-2.6-5-2.62z"
//         ></path>
//       </g>
//     </g>
//   </svg>
// );

export default SvgYoutubeFooter;
